import { defineComponent as _defineComponent } from 'vue'
import { ClientRiskCollateralProfile } from 'ah-api-gateways';
import { computed, PropType } from 'vue';
import FormattedCurrency from '../limitsAndCollateral/FormattedCurrency.vue';

/**
 * This component renders a utilization bar that visually represents the
 * client's collateral profile data, including Total Mark to Market (MTM) and
 * Variation Margin (VM) Limit. Also it has a zero marker for reference, so to the left of that
 * we have negative values and to the right we have positive values.
 * So if:
 *  - VM Limit is greater than MTM -> we will have only two zones: yellow and green
 *    - green zone - will always be 50%
 *    - yellow (warning) zone - will be also 50% and the VM Limit marker will be at the end, since it is the greater value
 *  - VM Limit is lesser than MTM -> we will have three zones: red, yellow and green
 *    - green zone - will always be 50%
 *    - yellow zone - since MTM is the greater value it means that it will represent 50%, so we need to calculate
 *    the warning zone based on that value (warningZonePercentage)
 *    - red zone - will be always 50% minus the yellow zone percentage
 **/


export default /*#__PURE__*/_defineComponent({
  __name: 'YourMTMPosition',
  props: {
  collateralProfileData: { type: Object as PropType<ClientRiskCollateralProfile>, required: true },
  inheritedHeight: { type: Number, required: true },
},
  setup(__props) {

const props = __props;



const isVMLimitGreaterThenMTM = computed(
  () => props.collateralProfileData.variationMarginAmount > Math.abs(props.collateralProfileData.totalMarkToMarket)
);

const warningZonePercentage = computed(() =>
  isVMLimitGreaterThenMTM.value
    ? 50
    : (props.collateralProfileData.variationMarginAmount * 50) / Math.abs(props.collateralProfileData.totalMarkToMarket)
);

const dangerZonePercentage = computed(() => 50 - warningZonePercentage.value);

/*
  The total bar has 100%, so on the left side of zero we have 50% and the same for the right side.
  To place the MTM marker correctly, since we are reading from left to right,
  meaning 0% on the left and 100% on the right, when the MTM value is negative we need to calculate the %
  inside of the negative 50% and then sum 50% to display the MTM market to the zero marker's left side (negative values)
 */
const mtmPercentage = computed(() => {
  if (isVMLimitGreaterThenMTM.value) {
    return (
      (props.collateralProfileData.totalMarkToMarket * 50) / props.collateralProfileData.variationMarginAmount + 50
    );
  } else {
    return props.collateralProfileData.totalMarkToMarket < 0 ? 0 : 100;
  }
});

return { __sfc: true,props, isVMLimitGreaterThenMTM, warningZonePercentage, dangerZonePercentage, mtmPercentage, FormattedCurrency }
}

})